import React from 'react';
import styled from 'styled-components';

interface StyleProps {
  size: number;
  color: string;
}

interface Props {
  color?: string;
  size?: number;
  title: string;
}

const H3 = ({ color = '#000', size = 18, title }: Props) => {
  return (
    <H3Style color={color} size={size}>
      {title}
    </H3Style>
  );
};

export default H3;

/* styles */

const H3Style = styled.h3<StyleProps>`
  font-size: ${({ size }) => `${size}px`};
  color: ${({ color }) => color};
`;
